import { AddCircle } from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';
import _ from 'lodash';
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import { paperWithTopLabelAndBottomValue } from '../uiComponent';
import { TextFieldWithTopLabelComponent } from '../uiComponent/fhirComponentUi';
import { IMaskInput } from 'react-imask';
import MuiPhoneNumber from 'material-ui-phone-number';
import { useMainFrameState } from '../../MainUIFrame/MainFrame';
import {
  prettifyPhone,
  removeSpecialCharsFromPhone,
} from '../../../config/common';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetStateDetectorState,
  setStateDetectorState,
} from '../../../redux/features/stateDetectorSlice';
import { red } from '@mui/material/colors';

const initialStateFromProps = (
  telecomArr = [],
  phoneUse,
  phoneWithExtension
) => {
  let phoneNumber = phoneWithExtension
    ? `+${
        telecomArr?.[
          _.findIndex(telecomArr, o => {
            return o?.system === 'phone' && o?.use === phoneUse;
          })
        ]?.extension?.[0]?.valueString
      } ${prettifyPhone(
        telecomArr?.[
          _.findIndex(telecomArr, o => {
            return o?.system === 'phone' && o?.use === phoneUse;
          })
        ]?.value
      )}`
    : telecomArr?.[
        _.findIndex(telecomArr, o => {
          return o?.system === 'phone' && o?.use === phoneUse;
        })
      ]?.value;

  let backupPhoneVal =
    telecomArr?.[
      _.findIndex(telecomArr, o => {
        return o?.system === 'phone' && o?.use === 'mobile';
      })
    ]?.value;
  let mobileNumber =
    phoneWithExtension && backupPhoneVal
      ? `+${
          telecomArr?.[
            _.findIndex(telecomArr, o => {
              return o?.system === 'phone' && o?.use === 'mobile';
            })
          ]?.extension?.[0]?.valueString
        } ${backupPhoneVal}`
      : telecomArr?.[
          _.findIndex(telecomArr, o => {
            return o?.system === 'phone' && o?.use === 'mobile';
          })
        ]?.value ?? '';

  let email =
    telecomArr?.[
      _.findIndex(telecomArr, o => {
        return (
          (o?.system === 'email' && o?.use === phoneUse) ||
          o?.system === 'email'
        );
      })
    ]?.value;

  return {
    phoneNumber,
    mobileNumber,
    email,
  };
};

const FHIRTelecom = forwardRef((props, ref) => {
  const selectedVersion = useSelector(
    state => state.changeVersion.selectedVersion
  );
  const { isDark } = useMainFrameState();

  let isShowPhoneWithExtension =
    props.hasOwnProperty('phoneWithExtension') && props?.phoneWithExtension;
  const [isEdit, setIsEdit] = useState(false);
  const { stateChangeActive = true } = props;

  const { npiData } = props;

  let primaryPhoneRef = useRef();
  let backupPhoneRef = useRef();

  const [telecomState, setTelecomState] = useState(
    initialStateFromProps(
      props?.telecomArray,
      props.use ? props.use : 'home',
      props.hasOwnProperty('phoneWithExtension') && props.phoneWithExtension
    )
  );

  // const [primaryPhone, setPrimaryPhone] = useState('');
  // const [backupPhone, setBackupPhone] = useState('');
  // const [phoneNumberValid, isPhoneNumberValid] = useState(true);
  // const [backupPhoneNumberValid, isBackupPhoneNumberValid] = useState(true);
  const [initialState, setInitialState] = useState({});
  const [isStateChanged, setIsStateChanged] = useState(false);
  // const [
  //   initialStateForPhoneWithExtension,
  //   setinitialStateForPhoneWithExtension,
  // ] = useState({});

  const reduxDispatch = useDispatch();

  // function formatPhoneNumber(phoneNumber) {
  //   let mobile = phoneNumber;
  //   if (phoneNumber.startsWith('+')) {
  //     let removedCountryCode = phoneNumber?.split(' ');
  //     removedCountryCode.shift();
  //     removedCountryCode = removedCountryCode.join(' ');

  //     mobile = removedCountryCode;
  //   }
  //   mobile = mobile.replace(/[^a-zA-Z0-9]/g, '');
  //   console.log(mobile);

  //   return mobile;
  // }

  // useEffect(() => {
  //   setinitialStateForPhoneWithExtension({
  //     ...telecomState,
  //     phoneNumber: telecomState?.phoneNumber
  //       ? formatPhoneNumber(telecomState?.phoneNumber)
  //       : '',
  //     mobileNumber: telecomState?.mobileNumber
  //       ? formatPhoneNumber(telecomState?.mobileNumber)
  //       : '',
  //     email: telecomState?.email ? telecomState?.email : '',
  //   });
  // }, []);

  // useEffect(() => {
  //   console.log(initialStateForPhoneWithExtension);
  // }, [initialStateForPhoneWithExtension]);

  useEffect(() => {
    setInitialState(telecomState);
  }, []);

  useEffect(() => {
    // if (isShowPhoneWithExtension) {
    //   if (
    //     typeof primaryPhone === 'string' &&
    //     typeof backupPhone === 'string' &&
    //     initialState?.email === telecomState?.email
    //   ) {
    //     reduxDispatch(setStateDetectorState({ isTelecomStateChanged: false }));
    //     setIsStateChanged(false);
    //   } else {
    //     let flag = false;
    //     if (typeof primaryPhone !== 'string') {
    //       if (
    //         !(
    //           (initialState?.phoneNumber
    //             ? formatPhoneNumber(initialState?.phoneNumber)
    //             : '') ===
    //           (primaryPhone?.phone
    //             ? formatPhoneNumber(primaryPhone?.phone)
    //             : '')
    //         )
    //       ) {
    //         flag = true;
    //       }
    //     }

    //     if (typeof backupPhone !== 'string') {
    //       if (!flag) {
    //         if (
    //           !(
    //             (initialState?.mobileNumber
    //               ? formatPhoneNumber(initialState?.mobileNumber)
    //               : '') ===
    //             (backupPhone?.phone
    //               ? formatPhoneNumber(backupPhone?.phone)
    //               : '')
    //           )
    //         ) {
    //           flag = true;
    //         }
    //       }
    //     }
    //     if (!flag) {
    //       if (
    //         !(
    //           [undefined, ''].includes(initialState?.email) &&
    //           [undefined, ''].includes(telecomState?.email)
    //         )
    //       ) {
    //         if (!(initialState?.email === telecomState?.email)) {
    //           flag = true;
    //         }
    //       }
    //     }
    //     setIsStateChanged(flag);
    //     reduxDispatch(setStateDetectorState({ isTelecomStateChanged: flag }));
    //   }
    // } else {
    if (stateChangeActive) {
      if (!isShowPhoneWithExtension) {
        const flag =
          JSON.stringify(initialState) !== JSON.stringify(telecomState);
        console.log(
          `IS_STATE_CHANGE_TELECOM`,
          flag,
          `STATE`,
          initialState,
          telecomState
        );
        setIsStateChanged(flag);
        reduxDispatch(setStateDetectorState({ isTelecomStateChanged: flag }));
      }
    }
    // }

    return () => {
      reduxDispatch(resetStateDetectorState());
    };
  }, [initialState, telecomState]);

  const [primaryPhone, setPrimaryPhone] = useState('');
  const [backupPhone, setBackupPhone] = useState('');
  const [phoneNumberValid, isPhoneNumberValid] = useState(true);
  const [backupPhoneNumberValid, isBackupPhoneNumberValid] = useState(true);

  useEffect(() => {
    if (isShowPhoneWithExtension) {
      setPrimaryPhone(telecomState?.phoneNumber);
      setBackupPhone(telecomState?.mobileNumber);
    }
  }, []);

  useEffect(() => {
    if (primaryPhone?.phone) {
      setPrimaryPhone(primaryPhone.phone);
    }
    if (backupPhone?.phone) {
      setBackupPhone(backupPhone?.phone);
    }
  }, [isShowPhoneWithExtension]);

  const homeNumberRef = useRef(null);
  const cellPhoneRef = useRef(null);
  const emailRef = useRef(null);

  useEffect(() => {
    console.log(`telecomState`, telecomState);
  }, [telecomState]);

  const TextMaskCustom = forwardRef((props, ref) => {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="(#00) 000-0000"
        definitions={{
          '#': /[1-9]/,
        }}
        inputRef={ref}
        onAccept={value => {
          let event = { target: { name: props?.name, value } };
          onChange(event);
        }}
      />
    );
  });

  const homeNumberValidationObject = {
    name: 'phoneNumber',
    value: telecomState?.phoneNumber,
    label: props.use === 'work' ? 'Business Phone' : 'Home Phone',
    validation: {
      required: true,
      min: 10,
      max: 10,
    },
    ref: homeNumberRef,
    // width: '95%',
    width: props?.fullWidth ? '100%' : '95%',
    // inputComponent: TextMaskCustom,
    mask: selectedVersion === 'IN' ? '9999-999999' : '(999) 999-9999',
  };

  const cellPhoneValidationObject = {
    name: 'mobileNumber',
    value: telecomState?.mobileNumber,
    label: 'Cell Phone',
    validation: {
      required: false,
      min: 10,
      max: 10,
    },
    ref: cellPhoneRef,
    // width: '95%',
    width: props?.fullWidth ? '100%' : '95%',
    mask: selectedVersion === 'IN' ? '9999-999999' : '(999) 999-9999',
  };

  const emailValidationObject = {
    name: 'email',
    value: telecomState?.email,
    label: 'Email',
    validation: {
      required: props?.hasOwnProperty('emailRequired')
        ? Boolean(props?.emailRequired)
        : true,
      min: 2,
      max: 500,
      pattern: /^\w+([.+]?\w+)*@\w+([.+]?\w+)*(\.\w{2,3})+$/,
    },
    ref: emailRef,
    // width: '95%',
    width: props?.fullWidth ? '100%' : '95%',
    emailRequired: Boolean(props?.emailRequired),
  };

  useEffect(() => {
    // console.log(initialStateFromProps(props?.telecomArray));
    setTelecomState(
      initialStateFromProps(props?.telecomArray, props.use ? props.use : 'home')
    );
  }, [props?.telecomArray]);

  useEffect(() => {
    setIsEdit(props?.isEdit);
  }, [props?.isEdit]);

  const handleOnChange = event => {
    const { name, value } = event?.target;
    setTelecomState({
      ...telecomState,
      [name]: value,
    });
  };

  useImperativeHandle(ref, () => ({
    handleOnUpdate() {
      let phoneObject = {};
      let mobileObject = {};
      let emailObject = {};
      phoneObject.system = 'phone';
      phoneObject.use = props.use ? props.use : 'home';
      let formattedPrimary =
        primaryPhoneRef?.current?.state?.formattedNumber.split(' ');
      let formattedBackup =
        backupPhoneRef?.current?.state?.formattedNumber.split(' ');
      phoneObject.value = isShowPhoneWithExtension
        ? {
            val: {
              countryCode:
                primaryPhoneRef?.current?.state?.selectedCountry?.iso2,
              dialCode: formattedPrimary[0].replace('+', ''),
              name: primaryPhoneRef?.current?.state?.selectedCountry?.name,
            },
            phone: primaryPhoneRef?.current?.state?.formattedNumber,
          }
        : telecomState?.phoneNumber === undefined
        ? ''
        : telecomState?.phoneNumber?.trim();

      mobileObject.system = 'phone';
      mobileObject.use = 'mobile';
      mobileObject.value = isShowPhoneWithExtension
        ? {
            val: {
              countryCode:
                backupPhoneRef?.current?.state?.selectedCountry?.iso2,
              dialCode: formattedBackup[0].replace('+', ''),
              name: backupPhoneRef?.current?.state?.selectedCountry?.name,
            },
            phone: backupPhoneRef?.current?.state?.formattedNumber,
          }
        : telecomState?.mobileNumber?.trim();

      emailObject.system = 'email';
      emailObject.use = props.use ? props.use : 'home';
      emailObject.value = telecomState?.email?.trim();

      let telecomArray = [];
      let validationData = [];

      let primaryPhoneTemp;
      // if (isShowPhoneWithExtension) {
      //   primaryPhoneTemp = phoneObject.value.phone.split(' ');
      //   Array.isArray(primaryPhoneTemp) && primaryPhoneTemp.shift();
      // }
      validationData.push(
        isShowPhoneWithExtension
          ? {
              valid: isValidPhoneNumber(phoneObject.value?.phone), //Array.isArray(primaryPhoneTemp) && removeSpecialCharsFromPhone(primaryPhoneTemp).length >= 10,
              value: primaryPhone,
            }
          : homeNumberRef?.current?.onValidate()
      );
      if (isShowPhoneWithExtension) {
        isPhoneNumberValid(isValidPhoneNumber(phoneObject.value?.phone));
      }

      validationData.push(
        isShowPhoneWithExtension
          ? {
              valid: mobileObject.value?.phone.replace(
                `+${mobileObject?.value?.val?.dialCode}`,
                ''
              )
                ? isValidPhoneNumber(mobileObject.value?.phone)
                : true,
              value: backupPhone || '',
            }
          : cellPhoneRef?.current?.onValidate()
      );

      if (isShowPhoneWithExtension) {
        isBackupPhoneNumberValid(
          mobileObject.value?.phone.replace(
            `+${mobileObject?.value?.val?.dialCode}`,
            ''
          )
            ? isValidPhoneNumber(mobileObject.value?.phone)
            : true
        );
      }

      validationData.push(emailRef?.current?.onValidate());

      let valid = true;
      for (let item of validationData) {
        // debugger;
        if (!item?.valid) {
          valid = false;
          break;
        }
      }

      [phoneObject, mobileObject, emailObject]?.map(item => {
        if (!_.isUndefined(item?.value) || !_.isEmpty(item?.value)) {
          telecomArray.push(item);
        }
      });

      telecomArray.valid = valid;
      telecomArray.isStateChanged = isStateChanged;

      return telecomArray;
    },
  }));

  useEffect(() => {
    if (npiData && Object.keys(npiData.data).length > 0) {
      let npi = npiData.data;
      if (npi.addresses.length > 1) {
        setTelecomState({
          ...telecomState,
          phoneNumber: npi?.addresses.length
            ? npi?.addresses[0]?.telephone_number?.replaceAll('-', '')
            : '',
        });
      }
    }
  }, [npiData]);

  const Required = () => <span style={{ color: 'red' }}>*</span>;

  return (
    <>
      <Grid container>
        <Grid item sx={12}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {props?.customTitle ? (
              props?.customTitle
            ) : (
              <>
                <AddCircle />
                <Typography>Contact Details</Typography>
              </>
            )}
          </Box>
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={1}>
        <Grid item xs={4}>
          {!isShowPhoneWithExtension && (
            <>
              {isEdit ? (
                <TextFieldWithTopLabelComponent
                  onChange={handleOnChange}
                  {...homeNumberValidationObject}
                />
              ) : (
                paperWithTopLabelAndBottomValue({
                  label: props.use == 'work' ? 'Business Phone' : 'Home Phone',
                  value: telecomState?.phoneNumber,
                })
              )}
            </>
          )}

          {isShowPhoneWithExtension && (
            <>
              <label
                className={`${
                  isDark ? 'sub-heading2-white' : 'sub-heading2'
                } f - 400`}
              >
                Primary Phone <span style={{ color: red[500] }}>*</span>
              </label>
              <MuiPhoneNumber
                sx={{
                  '& svg': { height: '.6em' },
                  width: `95 % `,
                  padding: '0 10px',
                  '& .MuiOutlinedInput-root': {
                    '& > fieldset': {
                      borderColor: 'textFieldColor',
                      borderWidth: 2,
                    },
                  },
                }}
                ref={primaryPhoneRef}
                fullWidth
                size="small"
                variant="outlined"
                error={!phoneNumberValid}
                // {...field}
                // label="Phone Number"
                // defaultCountry={'us'}
                defaultCountry={selectedVersion.toLowerCase()}
                onChange={(e, val) => {
                  let d = e.split(' ');
                  setPrimaryPhone({
                    val: {
                      ...val,
                      dialCode: d[0].replace('+', ''),
                    },
                    phone: e,
                  });
                }}
                value={primaryPhone}
                helperText={
                  !phoneNumberValid ? 'Please enter a valid phone number' : ''
                }
              />
            </>
          )}
        </Grid>
        <Grid item xs={4}>
          {!isShowPhoneWithExtension && (
            <>
              {isEdit ? (
                <TextFieldWithTopLabelComponent
                  onChange={handleOnChange}
                  {...cellPhoneValidationObject}
                />
              ) : (
                paperWithTopLabelAndBottomValue({
                  label: 'Cell Phone',
                  value: telecomState?.mobileNumber,
                })
              )}
            </>
          )}
          {isShowPhoneWithExtension && (
            <>
              <label
                className={`${
                  isDark ? 'sub-heading2-white' : 'sub-heading2'
                } f - 400`}
              >
                Backup Phone
              </label>
              <MuiPhoneNumber
                sx={{
                  '& svg': { height: '.6em' },
                  width: `95 % `,
                  padding: '0 10px',
                  '& .MuiOutlinedInput-root': {
                    '& > fieldset': {
                      borderColor: 'textFieldColor',
                      borderWidth: 2,
                    },
                  },
                }}
                fullWidth
                size="small"
                variant="outlined"
                ref={backupPhoneRef}
                error={!backupPhoneNumberValid}
                // {...field}
                // label="Phone Number"

                defaultCountry={selectedVersion.toLowerCase()}
                onChange={(e, val) => {
                  let d = e.split(' ');
                  setBackupPhone({
                    val: {
                      ...val,
                      dialCode: d[0].replace('+', ''),
                    },
                    phone: e,
                  });
                }}
                value={backupPhone}
                helperText={
                  !backupPhoneNumberValid
                    ? 'Please enter a valid phone number'
                    : ''
                }
              />
            </>
          )}
        </Grid>
        <Grid item xs={4}>
          {isEdit ? (
            <TextFieldWithTopLabelComponent
              onChange={handleOnChange}
              {...emailValidationObject}
            />
          ) : (
            paperWithTopLabelAndBottomValue({
              label: 'Email',
              value: telecomState?.email,
            })
          )}
        </Grid>
      </Grid>
    </>
  );
});

export default FHIRTelecom;
